import { register } from '../../../JavaScript/Utils'

const LifeCycle = el => {
  const buttonOrange = el.querySelector('.button-orange')
  const textOrange = el.querySelectorAll('.text-orange')
  const buttonYellow = el.querySelector('.button-yellow')
  const textYellow = el.querySelectorAll('.text-yellow')
  const buttonBlue = el.querySelector('.button-blue')
  const textBlue = el.querySelectorAll('.text-blue')

  buttonOrange.addEventListener('click', () => {
    buttonOrange.classList.toggle('inactive')
    textOrange.forEach(text => {
      text.classList.toggle('tansparent')
    })
  })

  buttonYellow.classList.add('inactive')
  textYellow.forEach(text => {
    text.classList.add('tansparent')
  })

  buttonYellow.addEventListener('click', () => {
    buttonYellow.classList.toggle('inactive')
    textYellow.forEach(text => {
      text.classList.toggle('tansparent')
    })
  })

  buttonBlue.classList.add('inactive')
  textBlue.forEach(text => {
    text.classList.add('tansparent')
  })

  buttonBlue.addEventListener('click', () => {
    buttonBlue.classList.toggle('inactive')
    textBlue.forEach(text => {
      text.classList.toggle('tansparent')
    })
  })
}

register('LifeCycle', LifeCycle)
